import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getFileType} from '../../../Utils/commonData'

type Props = {
  show: boolean
  onClose: () => void
  fileName: string
  viewUrl: string
}

export function BulkVosVosFormFileModal({show, onClose, fileName, viewUrl}: Props) {
  const [resolvedUrl, setResolvedUrl] = useState('')
  const blobUrlRef = useRef<string | null>(null)

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (!show || !viewUrl) {
      setResolvedUrl('')
      return
    }
    if (viewUrl.startsWith('blob:') || viewUrl.startsWith('http')) {
      setResolvedUrl(viewUrl)
      return
    }
    setResolvedUrl(viewUrl)
  }, [show, viewUrl])

  useEffect(() => {
    if (!show || !viewUrl || viewUrl.startsWith('blob:') || viewUrl.startsWith('http')) return
    if (getFileType(fileName) !== 'pdf') return
    let cancelled = false
    fetch(viewUrl)
      .then((res) => res.blob())
      .then((blob) => {
        if (cancelled) return
        if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current)
        const blobUrl = URL.createObjectURL(blob)
        blobUrlRef.current = blobUrl
        setResolvedUrl(blobUrl)
      })
      .catch(() => {
        if (!cancelled) setResolvedUrl(viewUrl)
      })
    return () => {
      cancelled = true
    }
  }, [show, viewUrl, fileName])

  if (!show) return null

  const isPdf = getFileType(fileName) === 'pdf'

  return (
    <div
      className='modal fade show d-block'
      style={{backgroundColor: 'rgba(0,0,0,0.55)'}}
      role='dialog'
      aria-modal='true'
      aria-labelledby='bulk-vos-vos-form-file-title'
    >
      <div className='modal-dialog modal-xl modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header py-3'>
            <h4 className='modal-title' id='bulk-vos-vos-form-file-title'>
              VOS form
            </h4>
            <button
              type='button'
              className='btn btn-icon btn-sm btn-active-light-primary'
              aria-label='Close'
              onClick={onClose}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
            </button>
          </div>
          <div className='modal-body p-0'>
            {isPdf ? (
              <iframe title='VOS form' src={resolvedUrl} frameBorder={0} width='100%' height='700px' />
            ) : (
              <img src={resolvedUrl} alt='VOS form' className='w-100 h-auto' />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
